import { GridService } from "../shared/grid/grid.service";

import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { SampleSurvey } from "../models/sampleSurvey.model";
import { SurveyProgressResponse } from "../models/survey-progress.model";
import nameOf from "../shared/form/nameOf.helper";

@Injectable({
    providedIn: "root",
})
export class SampleSurveyService extends GridService<SampleSurvey> {
    constructor(http: HttpClient) {
        super("SampleSurvey", http);
    }

    getSurveyProgress(
        organizationLevelId?: string,
    ): Observable<SurveyProgressResponse> {
        let params = new HttpParams();
        if (organizationLevelId != null) {
            params = params.set(
                nameOf<SampleSurvey>((x) => x.organizationLevelId),
                organizationLevelId,
            );
        }
        return this.http.get<SurveyProgressResponse>(
            this.getApiUrl(`${this.controllerName}/GetSurveyProgress`),
            { params },
        );
    }
}
